// 대시보드 검색 세대 관리
// 새 검색이 시작되면 이전 검색의 요청은 네트워크 단에서 취소(abort)되고,
// 이미 도착한 늦은 응답도 세대 비교로 무시된다.
let generation = 0;
let controller: AbortController | null = null;

// 새 검색 시작: 이전 세대의 진행 중인 요청을 모두 취소하고 세대를 올린다.
// 페이지의 검색/필터 적용 핸들러에서 setSearchReady(true) 전에 호출한다.
export const beginDashboardSearch = (): void => {
  generation += 1;
  controller?.abort();
  controller = new AbortController();
};

// 대시보드 조회 서비스 호출에 첨부되는 현재 세대의 AbortSignal
export const getDashboardSearchSignal = (): AbortSignal | undefined =>
  controller?.signal;

// 카드가 fetch 시작 시 호출해 세대를 캡처한다.
// 응답 처리(setState/토스트/로딩 해제) 전에 isCurrent()로 최신 검색인지 확인하고,
// 아니면 아무것도 하지 않는다 (새 검색의 로딩 상태를 건드리지 않기 위함).
export const captureDashboardSearch = (): { isCurrent: () => boolean } => {
  const captured = generation;
  return { isCurrent: () => captured === generation };
};
